import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  float: left;
  background: ${({ theme }) =>
    `linear-gradient(to bottom,${theme.colors.COLOR_1}, ${theme.colors.COLOR_1})`};
  position: fixed;
  height: 100%;
  left: 0px;
  top: 0px;
  display: flex;
  flex-direction: column;
`;
